import * as React from "react";
import { connect } from "react-redux";

import { Alert, Anchor, Group, Tabs } from "@mantine/core";
import { bindActionCreators } from "redux";
import { getManageableAssociations } from "../../../../data/actions/associationActions";
import {
  createShift,
  updateShift,
} from "../../../../data/actions/shiftActions";
import { getAllVenues } from "../../../../data/actions/venueActions";
import { IState } from "../../../../data/reducers/state";
import { IAssociation } from "../../../../types/association/Association";
import { IShift } from "../../../../types/shifts/Shift";
import { isNullOrWhitespace } from "../../../../util/string";
import { CenteredLoader } from "../../../common/loader";
import SessionEditor from "./SessionEditor";
import ShiftEditorOverviewTab from "./ShiftEditorOverviewTab";
import ShiftPersonsManager from "./ShiftPersonsManager";
import ShiftVenueEditor from "./ShiftVenueEditor";

interface IShiftEditorProps {
  onSave: Function;
  onCancel: Function;

  associations: IAssociation[];
  shiftId: string;
  defaultTab?: string;

  actions: any;
  shift: IShift;
}

interface IShiftEditorState {
  tab: string;
  saving?: boolean;
  saveError?: null | string;
}


class ShiftEditor extends React.PureComponent<
  IShiftEditorProps,
  IShiftEditorState
> {
  constructor(props, content) {
    super(props, content);

    // this.trySetNewShift(props.shift && props.shift._id, props)

    this.onChange = this.onChange.bind(this);
    this.onEventChange = this.onEventChange.bind(this);

    this.toggle = this.toggle.bind(this);

    if (!props.associations || props.associations?.length == 0) {
      props.actions.getManageableAssociations();
      props.actions.getAllVenues();
    }

    this.state = {
      saveError: null,
      tab: props.defaultTab || "Overview",
    };
  }

  toggle(tabKey) {
    this.setState((state) => ({ ...state, tab: tabKey }));
  }

  save(valuesToUpdate: Partial<IShift>) {
    this.setState({ saving: true, saveError: null });

    valuesToUpdate._id = this.props.shiftId;

    this.props.actions
      .updateShift(valuesToUpdate)
      .then((resp) => {
        this.setState({ saving: false });
        console.log(resp);
      })
      .catch((er) => {
        console.log("Error while saving shift", er);
        this.setState((state) => ({
          ...state,
          saving: false,
          saveError: er.message,
        }));
      });
  }

  onEventChange(e) {
    const t = e.currentTarget;
    if (!t) return console.log(e);
    this.onChange(t.name, t.value);
  }

  onChange(name: string, value: any) {
    if (!name) {
      throw new Error(
        "An internal error has occurred, there is no name property on the currently edited field",
      );
    }
    const parts: string[] = name.split(".");
    this.save({ [name]: value });
  }

  getNestedChange(obj: object, keyParts: string[], newValue: any): object {
    if (keyParts.length === 0) {
      throw Error(
        "An internal error has occurred: Invalid number of key parts",
      );
    }
    const key = keyParts[0];
    if (keyParts.length === 1) return { ...obj, [key]: newValue };

    const nested = obj[key] || {}; // create parts of the object we don't have
    return {
      ...obj,
      [key]: this.getNestedChange(nested, keyParts.slice(1), newValue),
    };
  }

  shiftIsValid(shift: IShift) {
    const errors: string[] = [];
    if (!shift.associationId) errors.push("association");
    if (isNullOrWhitespace(shift.name)) errors.push("shift name");

    return errors.length === 0;
  }

  render() {
    const { shift, associations } = this.props;

    if (!shift) return <></>;

    const isNew = !shift._id && shift._id != "new";

    const tabs = {
      Overview: (
        <ShiftEditorOverviewTab
          isNew={isNew}
          shift={shift}
          onEdit={this.onChange}
        />
      ),
      Persons: (
        <ShiftPersonsManager
          shift={shift}
          isNew={false}
          onEdit={this.onChange}
        />
      ),
      Sessions: <SessionEditor shiftId={shift._id} />,
      Venues: (
        <ShiftVenueEditor
          venues={shift.venues}
          associationId={shift.associationId}
          onEdit={this.onChange}
        />
      ),
    };

    return (
      <div>
        <h4>{shift.name}</h4>
        <br />
        <Alert color="blue">
          Changing a value on this page will immediately edit the shift. The
          save button has been removed.
        </Alert>
        <Tabs value={this.state.tab} onChange={(value) => this.toggle(value)}>
          <Tabs.List>
            {Object.keys(tabs).map((k) => (
              <Tabs.Tab key={k} value={k}>
                {k}
              </Tabs.Tab>
            ))}
          </Tabs.List>
          
          {Object.keys(tabs).map((k) => (
            <Tabs.Panel key={k} value={k} pt="sm">
              {tabs[k]}
            </Tabs.Panel>
          ))}
        </Tabs>

        {this.state.saving && <CenteredLoader />}
        {this.state.saveError && (
          <Alert color="red">{this.state.saveError}</Alert>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: IState, ownProps: IShiftEditorProps) {
  return {
    associations: state.associations.admin,
    shift: state.shifts.map[ownProps.shiftId],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getManageableAssociations,
        createShift,
        updateShift,
        getAllVenues,
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShiftEditor);
